import CircleLogo from './CircleLogo.svg';
import LoginPageTruck from './LoginPageTruck.svg';
import Logo from './Logo.svg';
import ShippingTruck from './ShippingTruck.svg';
import YubiKey from './YubiKey.svg';

const ICONS = {
  CircleLogo,
  LoginPageTruck,
  Logo,
  ShippingTruck,
  YubiKey,
};

export type YubiIconTypes = keyof typeof ICONS;

export default ICONS;
